import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const GamesIcon = ({ color = '#333131' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="28px"
			viewBox="3 3 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.5417 27.125H6.45833C5.77319 27.125 5.11611 26.8528 4.63164 26.3684C4.14717 25.8839 3.875 25.2268 3.875 24.5417V6.45833C3.875 5.77319 4.14717 5.11611 4.63164 4.63164C5.11611 4.14717 5.77319 3.875 6.45833 3.875H20.6667L27.125 10.3333V24.5417C27.125 25.2268 26.8528 25.8839 26.3684 26.3684C25.8839 26.8528 25.2268 27.125 24.5417 27.125Z"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.9582 27.1248V16.7915H9.0415V27.1248"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.0415 3.875V10.3333H19.3748"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
